"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isApplicationErrorCode = exports.isTRPCErrorResponse = exports.isTRPCClientError = exports.getPreferredErrorMessage = exports.isDataLayerError = exports.isNotLoggedInError = exports.isNotFoundError = exports.isTimeoutError = exports.isPermissionError = exports.isNetworkError = exports.isHTTPError = void 0;
var fetcher_1 = require("@newfront-insurance/fetcher");
var get_1 = __importDefault(require("lodash/get"));
var isObject_1 = __importDefault(require("lodash/isObject"));
var http_error_1 = require("./http-error");
function isHTTPError(error) {
    return error instanceof Error && error.name === 'HTTPError';
}
exports.isHTTPError = isHTTPError;
function isNetworkError(error) {
    return error instanceof Error && error.name === 'NetworkError';
}
exports.isNetworkError = isNetworkError;
function isPermissionError(error) {
    if (error instanceof Error && error.name === 'PermissionError') {
        return true;
    }
    if (isHTTPError(error)) {
        return error.response.status === 402 || error.response.status === 403;
    }
    return false;
}
exports.isPermissionError = isPermissionError;
function isTimeoutError(error) {
    if (error instanceof Error && error.name === 'TimeoutError') {
        return true;
    }
    if (isHTTPError(error)) {
        return error.response.status === 408;
    }
    return false;
}
exports.isTimeoutError = isTimeoutError;
function isNotFoundError(error) {
    if (error instanceof Error && error.name === 'NotFoundError') {
        return true;
    }
    if (isHTTPError(error)) {
        return error.response.status === 404;
    }
    return false;
}
exports.isNotFoundError = isNotFoundError;
function isNotLoggedInError(error) {
    if (error instanceof Error && error.name === 'NotLoggedInError') {
        return true;
    }
    if (isHTTPError(error)) {
        return error.response.status === 401;
    }
    return false;
}
exports.isNotLoggedInError = isNotLoggedInError;
/**
 * Checks to see if an error is any type of data layer error. This could be a network error,
 * a timeout error, a permission error, a not found error, or a not logged in error.
 */
function isDataLayerError(error) {
    if (isHTTPError(error) || isNetworkError(error) || isTimeoutError(error)) {
        return true;
    }
    if (isNotLoggedInError(error) || isNotFoundError(error) || isPermissionError(error)) {
        return true;
    }
    return false;
}
exports.isDataLayerError = isDataLayerError;
/**
 * Get the preferred error message from an error object. If the error is
 * a HTTP error, the error message from the downstream API service will be returned if it exists.
 * If not, it will try to return the error message from the API client in the BFF.
 */
function getPreferredErrorMessage(error) {
    // The TRPCClientError will wrap other types of errors, so we
    // really want the error message of the cause.
    if (isTRPCClientError(error) && error.cause) {
        return getPreferredErrorMessage(error.cause);
    }
    // If it's a HTTP error we should try to get the error message from the downstream service.
    // This will give us more information that a generic HTTP error message.
    if (isHTTPError(error)) {
        var body = error.responseBody;
        if (isTRPCErrorResponse(body)) {
            var _a = body.error.json, applicationError = _a.applicationError, fetcherError = _a.fetcherError;
            return (applicationError === null || applicationError === void 0 ? void 0 : applicationError.message) || (fetcherError === null || fetcherError === void 0 ? void 0 : fetcherError.message) || error.message;
        }
    }
    // Default to using the standard error message.
    return error.message;
}
exports.getPreferredErrorMessage = getPreferredErrorMessage;
/**
 * Check if an error is a TRPCClientError. This is a special error that is thrown
 * when the TRPC client encounters an error during a HTTP request.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isTRPCClientError(error) {
    return error instanceof Error && error.name === 'TRPCClientError';
}
exports.isTRPCClientError = isTRPCClientError;
/**
 * Checks to see if an object looks like a TRPC error response body. This is the shape
 * that is returned from the BFF when there is an error in a resolver.
 */
function isTRPCErrorResponse(responseBody) {
    if (!(0, isObject_1.default)(responseBody)) {
        return false;
    }
    return !!(0, get_1.default)(responseBody, 'error.json');
}
exports.isTRPCErrorResponse = isTRPCErrorResponse;
/**
 * Checks whether the passed-in error is included in a list of passed-in application error codes.
 * Can be used to surface mutation errors to the user.
 */
function isApplicationErrorCode(error, validationErrorCode) {
    var errorCause = isTRPCClientError(error) && error.cause ? error.cause : error;
    if (errorCause instanceof http_error_1.HTTPError) {
        var body = errorCause.responseBody;
        if (isTRPCErrorResponse(body)) {
            var fetcherError = body.error.json.fetcherError;
            if ((0, fetcher_1.isFetcherErrorLike)(fetcherError)) {
                var _a = fetcherError.fetcherResponse, statusCode = _a.statusCode, data = _a.data;
                if (statusCode >= 400 && typeof data === 'object' && data !== null && 'errorCode' in data) {
                    var errorCode = data.errorCode;
                    return validationErrorCode.includes(errorCode);
                }
            }
        }
    }
    return false;
}
exports.isApplicationErrorCode = isApplicationErrorCode;
